export class NavService {
  history;
  initRefNav(history) {
    this.history = history;
  }

}
export const navService = new NavService();
